import { createFileRoute } from '@tanstack/react-router';
import { S2Fleet } from '@/screens/S2Fleet/S2Fleet';

const VIEWS = ['cards', 'table', 'map'] as const;
type FleetView = (typeof VIEWS)[number];

type FleetSearch = {
  view: FleetView;
  q?: string;
};

export const Route = createFileRoute('/$orgId/fleet')({
  validateSearch: (raw: Record<string, unknown>): FleetSearch => {
    const view = VIEWS.includes(raw.view as FleetView)
      ? (raw.view as FleetView)
      : 'cards';
    const q = typeof raw.q === 'string' && raw.q.length > 0 ? raw.q : undefined;
    return { view, q };
  },
  component: S2Fleet,
});
